import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Globals } from '../../app.globals';
import { CreatePlaylistForm } from '../../../models/';
import { SongsService, PlaylistService, MessagesServices } from '../../api/';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import { DndModule } from 'ng2-dnd';
import * as _ from 'lodash';
import { MdDialogRef } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
declare var $: any;

@Component({
  selector: 'edit-playlist',
  templateUrl: './edit-playlist.component.html',
  styleUrls: ['./edit-playlist.component.css']
})
export class EditPlaylistComponent implements OnInit {
  private image: any;
  private model: CreatePlaylistForm;
  private songs: Array<any> = new Array<any>();
  private isImageChanged: boolean = false;
  public playlist: any;
  private messages: any = new Array<any>();
  msg1: any = '';
  title1: any = '';
  public toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],

    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  ];
  public editorConfig = {
    placeholder: "Full description",
    modules: {
      toolbar: this.toolbarOptions
    },
    theme: 'snow'
  };
  @BlockUI() blockUI: NgBlockUI;
  public onlineOffline1: boolean = navigator.onLine;
  sortOrder: any;
  public apiUrl: string = new Globals().apiEndpoint;
  imageSource: string;
  loading: boolean = false;
  newOrder: any[];
  updatedImagePath: string;
  previousAvatar: any;

  constructor(public dialogRef: MdDialogRef<EditPlaylistComponent>, private sm: MessagesServices, private songsService: SongsService,
  private playlistService: PlaylistService, private toastyService: ToastyService) {
    window.addEventListener('online', () => {this.onlineOffline1 = true; });
    window.addEventListener('offline', () => {this.onlineOffline1 = false});
    this.model = new CreatePlaylistForm();
    //getting messages from db
    this.messages = this.sm.messags;
    this.setMessages();
  }

  ngOnInit() {
    this.model.id = this.playlist.id;
    this.model.name = this.playlist.name;
    this.model.visibility = this.playlist.visibility;
    this.model.description = this.playlist.description;
    this.model.created_by = this.playlist.created_by
    this.model.bio = this.playlist.bio;
    this.previousAvatar = this.playlist.playlist_image;
    this.image = this.playlist.playlist_image;
    this.blockUI.start('Loading, please wait...');
    let queryParams = '';
    if (this.playlist.songsId.length > 0) {
      this.playlist.songsId.forEach(function (arrayItem) {
        queryParams += 'id[]=' + arrayItem + '&';
      });
      if (this.sortOrder && this.sortOrder.key) {
        queryParams += 'sortBy=' + this.sortOrder.key + '&sortOrder=' + this.sortOrder.sortOrder;
      }
    }
    var that = this;
    $.get(this.apiUrl+"songs?" + queryParams).done((res) => {
      that.songs = res;
      that.blockUI.stop();
    });
  }

  /**
   * setting system messages
   **/
  setMessages() {
    this.msg1 = '';
    this.title1 = '';
    if (this.messages) {
      for (var i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_PLAYLIST_UPDATED_SUCCESSFULLY') {
          this.title1 = this.messages[i].title;
        }
      }
    }
  }

  saveChanges() {
    this.loading = true;
    var that = this;
    if(this.onlineOffline1) {
      $.ajaxSetup({
        headers:{
          "Accept" : "application/json; charset=utf-8",
          "Authorization": 'Bearer '+ localStorage.getItem('auth_token')
        },
      });
      // playlist update api call
      $.post(that.apiUrl + 'playlists/update?id=' + this.model.id, this.model).done((res) => {
        if(this.isImageChanged) {
          let image = that.image.replace(/^data:image\/(png|jpeg);base64,/, '');
          var imageSrc = new Image();
          imageSrc.src = 'data:image/png;base64,' + image;
          this.playlistService.playlistAvatarUpdated.next(imageSrc.src);
          // avatar update api call
          $.post(that.apiUrl + 'playlists/upload-playlist-avatar', { id: that.playlist.id, image: image }).done((result) => {
            this.updatedImagePath = 'https://mspro-shortened.s3.amazonaws.com/assets/playlist/' + result.image;
            let toastOptions: ToastOptions = {
              title: that.title1,
              msg: result.msg,
              showClose: true,
              timeout: 2000,
              theme: 'default'
            };
            // to update the playlist in local storage if the avatar is changed
            if(res) {
              var localStoragePlaylists = [];
              localStoragePlaylists = JSON.parse(localStorage.getItem('playlistDetail'));
              if(localStoragePlaylists.length > 0) {
                let index = localStoragePlaylists.findIndex(x => x.id == this.model.id);
                if(index != -1) {
                  localStoragePlaylists[index] = res;
                  localStoragePlaylists[index].playlist_image = this.updatedImagePath;
                  localStorage.setItem("playlistDetail" , JSON.stringify(localStoragePlaylists));
                }
              }
            }
            that.toastyService.success(toastOptions);
            that.dialogRef.close(true);
            that.playlistService.isPlaylistUpdated.next(true);
            that.loading = false;
          }).fail((err) => {
            that.playlistService.playlistAvatarUpdated.next(that.previousAvatar);
            that.loading = false;
            that.dialogRef.close(true);
            alert('Something went wrong with Server');
          });
        } else {
          // to update the playlist in local storage if the avatar is not changed
          if(res) {
            var localStoragePlaylists = [];
            localStoragePlaylists = JSON.parse(localStorage.getItem('playlistDetail'));
            if(localStoragePlaylists.length > 0) {
              let index = localStoragePlaylists.findIndex(x => x.id == this.model.id);
              if(index) {
                localStoragePlaylists[index] = res;
                localStorage.setItem("playlistDetail" , JSON.stringify(localStoragePlaylists));
              }
            }
          }
          that.loading = false;
          let toastOptions: ToastOptions = {
            title: this.title1,
            msg: "Playlist is updated successfully.",
            showClose: true,
            timeout: 2000,
            theme: 'default'
          };
          that.toastyService.success(toastOptions);
          that.dialogRef.close(true);
          that.playlistService.isPlaylistUpdated.next(true);
        }
      });
    }
    this.blockUI.stop();
  }

  fileChangeListener($event) {
    this.image = new Image();
    let file: File = $event.target.files[0];
    this.imageSource = $event.target.value;
    let myReader: FileReader = new FileReader();
    let that = this;
    myReader.onloadend = function(loadEvent: any) {
      that.image = loadEvent.target.result;
      that.isImageChanged = true;
    };
    myReader.readAsDataURL(file);
  }

  private onDropModel(args) {
    this.newOrder = [];
    let i = 0;
    this.playlist.songsId = []
    this.songs.forEach((arrayItem) => {
      let song: any = {};
      let tmp: any = _.pick(arrayItem, ['id']);
      song.song_id = tmp.id;
      song.order = i;
      i++;
      this.newOrder.push(song);
      this.playlist.songsId.push(song.song_id);
    });
  }

  updateSongsOrder() {
    if(window.confirm('Are sure you want to update the order of songs?')) {
      $.ajaxSetup({
        headers:{
          "Content-Type": "application/json; charset=utf-8",
          "Accept" : "application/json; charset=utf-8",
          "Authorization": 'Bearer '+ localStorage.getItem('auth_token')
        },
      });
      $.post(this.apiUrl + 'playlists/songs-sort?id=' + this.model.id, JSON.stringify(this.newOrder)).done((res) => {
        window.location.reload();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/playlists/edit-playlist/edit-playlist.component.ts